export default __webpack_public_path__ + "static/media/Rajneeti1.7ffde582.mp4";